module.exports = __webpack_public_path__ + "static/media/creative-commons-sampling.5d139c0c.svg";